import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { first } from 'lodash';

import S from 'constants/string.const';
import getVacationType from 'constants/timeoff/vacationType..const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './CategoryTimeOffV1.module.scss';

const DATA = Object.freeze([
  Object.freeze({ who: 'Alice', allowed: '25', used: '2', remaining: '23' }),
  Object.freeze({ who: 'Bob', allowed: '20', used: '20', remaining: '0' }),
  Object.freeze({ who: 'Charlie', allowed: '25', used: '20', remaining: '5' }),
]);

const CategoryTimeOffItem = ({ emoji, index, type }) => (
  <div data-bem="CategoryTimeOffItem" data-index={index} className={CN.categoryItem}>
    {emoji}
    {S.space}
    {type}
  </div>
);

const CategoryTimeOffV1 = ({ calendarMode }) => {
  const { t } = useTranslation();

  const VACATION_TYPE = getVacationType(t);

  const firstVacationType = first(VACATION_TYPE);

  return (
    <div data-bem="CategoryTimeOff" className={cn(CN.banner, CN[calendarMode])}>
      <div className={CN.title}>
        <span data-bem="CategoryTimeOff__emoji-before" className={CN.emoji} role="img" aria-labelledby="Sound">
          {S.megaphone}
        </span>
        {S.space}
        {S.space}
        {t('scheduler.bookTimeOff.categoryTimeOffTable.title')}
        {S.space}
        {S.space}
        <span data-bem="CategoryTimeOff__emoji-after" className={CN.emoji} role="img" aria-labelledby="Sound">
          {S.megaphone}
        </span>
      </div>
      <div data-bem="CategoryTimeOff__note-1" className={CN.note}>
        {t('scheduler.bookTimeOff.categoryTimeOffTable.guideline1')}
      </div>
      <section data-bem="CategoryTimeOff__categories" className={CN.categoryList}>
        {VACATION_TYPE.map(({ emoji, type }, index) => (
          <CategoryTimeOffItem key={type} index={index} emoji={emoji} type={type} />
        ))}
      </section>
      <div data-bem="CategoryTimeOff__note-2" className={CN.note}>
        {t('scheduler.bookTimeOff.categoryTimeOffTable.guideline2')}
      </div>
      <table data-bem="CategoryTimeOff__table" className={CN.table}>
        <thead>
          <tr>
            <th>
              <CategoryTimeOffItem {...firstVacationType} />
            </th>
            <th>{t('scheduler.bookTimeOff.categoryTimeOffTable.tableHeaders.Allowed')}</th>
            <th>{t('scheduler.bookTimeOff.categoryTimeOffTable.tableHeaders.Used')}</th>
            <th>{t('scheduler.bookTimeOff.categoryTimeOffTable.tableHeaders.Remaining')}</th>
          </tr>
        </thead>
        <tbody>
          {DATA.map(({ allowed, remaining, used, who }) => (
            <tr key={`${who}+${allowed}`}>
              <td>{who}</td>
              <td>
                {allowed} {t('scheduler.bookTimeOff.categoryTimeOffTable.days')}
              </td>
              <td>
                {used} {t('scheduler.bookTimeOff.categoryTimeOffTable.days')}
              </td>
              <td>
                {remaining} {t('scheduler.bookTimeOff.categoryTimeOffTable.days')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

const CategoryTimeOffV1Hoc = connect(mapStateToProps)(CategoryTimeOffV1);

export default CategoryTimeOffV1Hoc;
